import { useEffect } from "react"

import { useOrganization, useUser } from "@clerk/nextjs"

import { useAnalytics } from "../useAnalytics"

export function PostHogIdentify() {
  const { user } = useUser()
  const { organization } = useOrganization()
  const { identify } = useAnalytics()

  useEffect(() => {
    if (!user || !organization) {
      return
    }

    identify(user.id, {
      email: user.primaryEmailAddress?.emailAddress,
      name: user.fullName,
      organization: organization.slug,
    })

    if (user.primaryEmailAddress?.emailAddress) {
      window.pylon = {
        chat_settings: {
          app_id: "0e0fbf0b-5664-4fd7-a185-893b30dfcd05",
          email: user.primaryEmailAddress.emailAddress,
          name: user.fullName || user.firstName || "User",
          avatar_url: user.imageUrl,
          account_id: organization.id,
        },
      }
    }
  }, [user, organization, identify])

  return null
}
